const converter = {
    2: convertToFromV2,
    3: convertToFromV3,
    4: pass,
};

/**
 * 이전 버전 페이로드에서 최신 페이로드로 변경
 * @param payload
 * @returns {*}
 */
export function convertToLatestEnrolmentPayload(payload) {
    return converter[payload.version](payload);
}

/**
 * 최신 버전인 경우 그대로 다시 반환
 * @param payload
 * @returns {*}
 */
function pass(payload) {
    return payload;
}

/**
 * 버전 2에서 변경
 * @param payload
 * @returns {*}
 */
function convertToFromV2(payload) {
    return convertToFromV3({
        version: 3,
        images: payload.image ? [payload.image] : [],
        ...payload,
    });
}

function convertToFromV3(payload) {
    return {
        ...payload,
        version: 4,
        questions: payload.questions.map(question => ({
            ...question,
            programs: question.programs.map(program => ({
                programNo: program.programNo,
                programNumber: program.programNumber,
                programName: program.programName,
                limit: program.limit,
                reservedLimit: program.reservedLimit,
                filters: program.filterTags,
                times: [],
                costs: [
                    {
                        name: '강사료',
                        value: program.강사료,
                    },
                    {
                        name: '수용비',
                        value: program.수용비,
                    },
                    {
                        name: '교재/교구비',
                        value: program.교재교구비,
                    },
                ],
                drawPriors: [],
            })),
        })),
    }
}